import {
  Paper,
  Box,
  Typography,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from '@mui/material';
import {
  FilterList as FilterListIcon,
  Clear as ClearIcon,
  Search as SearchIcon,
} from '@mui/icons-material';

/**
 * Filtros para schedules
 */
export default function ScheduleFilters({
  searchTerm,
  onSearchChange,
  filterProfessional,
  onProfessionalChange,
  filterPlace,
  onPlaceChange,
  professionals = [],
  places = [],
  onClearFilters,
}) {
  const hasActiveFilters = searchTerm || filterProfessional || filterPlace;

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <FilterListIcon sx={{ mr: 1 }} />
        <Typography variant="h6">Filtros</Typography>
        <Button
          startIcon={<ClearIcon />}
          onClick={onClearFilters}
          sx={{ ml: 'auto' }}
          disabled={!hasActiveFilters}
        >
          Limpar Filtros
        </Button>
      </Box>
      
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="Buscar por nome da agenda"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active' }} />,
            }}
            placeholder="Digite o nome da agenda..."
          />
        </Grid>
        
        <Grid item xs={12} md={4}>
          <FormControl fullWidth>
            <InputLabel>Filtrar por Profissional</InputLabel>
            <Select
              value={filterProfessional}
              onChange={(e) => onProfessionalChange(e.target.value)}
              label="Filtrar por Profissional"
            >
              <MenuItem value="">Todos os Profissionais</MenuItem>
              {professionals.map((prof) => (
                <MenuItem key={prof.id} value={prof.id}>
                  {prof.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <FormControl fullWidth>
            <InputLabel>Filtrar por Local</InputLabel>
            <Select
              value={filterPlace}
              onChange={(e) => onPlaceChange(e.target.value)}
              label="Filtrar por Local"
            >
              <MenuItem value="">Todos os Locais</MenuItem>
              {places.map((place) => (
                <MenuItem key={place.id} value={place.id}>
                  {place.name} {place.addressCity ? `(${place.addressCity})` : ''}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Paper>
  );
}
